import { render, staticRenderFns } from "./newsTrend.vue?vue&type=template&id=c2d9bfee&scoped=true"
import script from "./newsTrend.vue?vue&type=script&lang=js"
export * from "./newsTrend.vue?vue&type=script&lang=js"
import style0 from "./newsTrend.vue?vue&type=style&index=0&id=c2d9bfee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../usr/local/node_16.9.1/lib/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d9bfee",
  null
  
)

export default component.exports